package one.healthium.uscreen.domain.models

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
enum class StatusBarStyle {
    @SerialName("dark") Dark,
    @SerialName("light") Light,
}

@Serializable
enum class TextAlignment {
    @SerialName("left") Left,
    @SerialName("center") Center,
    @SerialName("right") Right,
}

@Serializable
enum class ChoiceAnimation {
    @SerialName("stagger") Stagger,
    @SerialName("none") None,
}

@Serializable
enum class ImageFit {
    @SerialName("crop") Crop,
    @SerialName("fit") Fit,
    @SerialName("fill_bounds") FillBounds,
    @SerialName("fill_width") FillWidth,
    @SerialName("fill_height") FillHeight,
    @SerialName("inside") Inside,
    @SerialName("none") None,
}

@Serializable
enum class ImageAlignment {
    @SerialName("center") Center,
    @SerialName("top") Top,
    @SerialName("bottom") Bottom,
    @SerialName("top_start") TopStart,
    @SerialName("top_end") TopEnd,
    @SerialName("bottom_start") BottomStart,
    @SerialName("bottom_end") BottomEnd,
    @SerialName("center_start") CenterStart,
    @SerialName("center_end") CenterEnd,
}

@Serializable
enum class TextCapitalization {
    @SerialName("none") None,
    @SerialName("words") Words,
    @SerialName("sentences") Sentences,
    @SerialName("characters") Characters,
}

@Serializable
enum class KeyboardType {
    @SerialName("text") Text,
    @SerialName("default") Default,
    @SerialName("number") Number,
    @SerialName("email") Email,
}
